import styled, { keyframes } from 'styled-components';

type SizeType = 'small' | 'medium' | 'large';

const progressAnimation = keyframes`
	0% {
		width: 0%;
	}
	100% {
		width: 100%;
	}
`;

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	margin-bottom: 200px;
	margin-top: 100px;
`;

export const Text = styled.div`
	font-weight: 600;
	color: ${({ theme }) => theme.colors.text.alwaysWhite};
	text-align: center;
	margin-bottom: 32px;
`;

export const ProgressWrapper = styled.div`
	background-color: ${({ theme }) => theme.colors.background.secondary};
	border-radius: 133px;
	height: 8px;
	width: 236px;
	overflow: hidden;
`;

export const ProgressBar = styled.div`
	background-color: ${({ theme }) => theme.colors.control.primary};
	border-radius: 133px;
	height: 100%;
	width: 0;
	animation: ${progressAnimation} 0.5s ease-in-out forwards;
`; 